const formatDateValue = (value, needISODateFormat = false) => {
  if (needISODateFormat) {
    return value.split(`.`).reverse().join(`-`);
  }

  return value.split(`-`).reverse().join(`.`);
};

const getDate = (date, dateType, value) => {
  const newDate = new Date(date);
  newDate[`set${dateType}`](newDate[`get${dateType}`]() + value);
  return newDate;
};

const getDateInFormat = (date, format) => {
  let dateFormat = '';
  let ye = new Intl.DateTimeFormat('en', {year: 'numeric'}).format(date);
  let mo = new Intl.DateTimeFormat('en', {month: '2-digit'}).format(date);
  let da = new Intl.DateTimeFormat('en', {day: '2-digit'}).format(date);
  switch(format) {
    case 'Y-m-d':
      dateFormat = `${ye}-${mo}-${da}`;
      break;
    default:
      dateFormat = `${da}.${mo}.${ye}`;
  }
  return dateFormat;
};

export { formatDateValue, getDate, getDateInFormat };
